module.exports = __webpack_public_path__ + "img/new-logo.bfebf25c.svg";